<template>
    <div class="workshops">
        <Navigation/>
        <v-main>
            <v-container>
                <v-row>
                    <v-col cols=12>
                        <workshops-list
                            :title="title"
                            :workshops="workshops"
                            :options.sync="options"
                            :search="search"
                            :total="total"
                            :loading="loading"
                            :loading-more="loadingMore"
                            :has-more="hasMore"
                            :all-departments="allDepartments"
                            :all-cities="allCities"
                            :departments-loading="departmentsLoading"
                            :cities-loading="citiesLoading"
                            :professionals-names="professionalsNames"
                            :professionals-names-loading="professionalsNamesLoading"
                            :slider="slider"
                            :show-banner="!!showBanner"
                            :is-aja="isAjaWorkshops"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import WorkshopsList from '@/components/workshops/WorkshopsList'
import workshopsList from '@/mixins/workshopsList'
import { mapActions } from 'vuex'

export default {
    name: 'Workshops',
    data() {
        return {
            search: {
                ...(this.$route.query.search ? JSON.parse(this.$route.query.search) : {}),
                active: true,
                'is_aja': this.$route.name === 'AJAWorkshops',
                'aja_ref': this.$route.name === 'AJAWorkshops' ? 'oncog_aja' : undefined,
                'is_pro': this.$route.name === 'WorkshopsPro',
                workshop_type: this.$route.name === 'WorkshopsPro' ? 'pro' : 'cognitive'
            },
            profile: null
        }
    },
    components: {
        Navigation,
        WorkshopsList
    },
    mixins: [workshopsList],
    mounted() {
        // Set AJA theme if needed
        if (this.$route.name === 'AJAWorkshops') {
            this.setThemeAja(true)
        }
        
        this.refreshPagination(true)
        this.initAdvancedSearch()
        this.initLogos()
        if (this.$store.getters.getProfile.id) {
            this.getUser()
        }
    },
    computed: {
        showBanner() {
            return this.profile?.show_oncommence_banner
        },
        title() {
            return this.$route.name === 'AJAWorkshops' 
                ? 'Les ateliers de remédiation AJA' 
                : 'Les ateliers de remédiation cognitive'
        },
        isAjaWorkshops() {
            return this.$route.name === 'AJAWorkshops'
        }
    },
    methods: {
        ...mapActions(['setThemeAja']),
        getUser() {
            this.$store.dispatch('userRequest', { id: this.$store.getters.getProfile.id })
                .then(result => {
                    this.profile = result.data
                })
                .catch((err) => {
                    this.$store.dispatch('setErrors', err.response.data)
                })
        }
    }
}
</script>